module.exports = __webpack_public_path__ + "static/media/close.9a050f56.svg";